import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
//import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"; // Import Routes and other components
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Component/Login";
//import Dashboard from "./Component/Dashboard";
import Logout from "./Component/Logout";
import Home from "./Component/Home";

const App = () => (
  <AuthProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/home"
          element={<ProtectedRoute element={<Home />} />}
          //element={<Dashboard />}
        />

        <Route
          path="/logout"
          element={<ProtectedRoute element={<Logout />} />}
        />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  </AuthProvider>
);

export default App;
